import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Dialog } from 'primeng/dialog';
import { LicenseService } from '../../../../../services/remote/license.service';

@Component({
  selector: 'cognos-license-details-remote-sources',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    TableModule,
    TagModule,
    FloatLabelModule,
    ColorPickerModule,
    InputNumberModule,
    InputTextModule,
    TextareaModule,
    DividerModule,
    TooltipModule,
    DatePipe,
    Dialog,
  ],
  templateUrl: './license-details-remote-sources.component.html',
  styleUrl: './license-details-remote-sources.component.scss',
})
export class LicenseDetailsRemoteSourcesComponent {
  @Input() remoteSourcesList: any;
  @Input({ required: true }) licenseId!: string;
  public filterText: string = '';

  public remoteSources: any[] = [];

  public isLoading = false;

  public isOpen = false;
  public newRemoteSource: any = {
    name: '',
    plugin: '',
    remoteAddress: '',
  };

  public get filteredRemoteSources(): any[] {
    const q = (this.filterText || '').trim().toLowerCase();
    if (!q) return this.remoteSources;
    return this.remoteSources.filter((a) => {
      const name = (a?.name || a?.label || a?.type || '')
        .toString()
        .toLowerCase();
      return name.includes(q);
    });
  }

  constructor(private licenseService: LicenseService) {}

  public ngOnChanges(): void {
    this.remoteSources = this.remoteSourcesList || [];
  }

  public openModal(): void {
    this.isOpen = true;
  }
  public closeModal(): void {
    this.isOpen = false;
    this.newRemoteSource = {
      name: '',
      plugin: '',
      remoteAddress: '',
    };
  }

  public createRemoteSource(): void {
    this.isLoading = true;
    this.licenseService
      .createRemoteSource(this.newRemoteSource, this.licenseId)
      .then((res) => {
        this.isLoading = false;
        if (res === 'ok') {
          this.licenseService
            .fetchRemoteSourcesList(this.licenseId)
            .then(() => {
              this.remoteSources = this.licenseService.remoteSourcesList$();
              this.closeModal();
            });
        }
      });
  }
}
